import { Button, Grid, InputAdornment, TextField } from "@mui/material";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { useSuperAdminUsers } from "../../../context/SuperAdmin/UsersContext";
import { useEffect, useState } from "react";

const HeadersUsersTable = () => {
  const { searchQuery, handleSearchQuery, toggleCreateModal } =
    useSuperAdminUsers();

  const [inputValue, setInputValue] = useState(searchQuery);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (inputValue !== searchQuery) {
        handleSearchQuery({
          target: { value: inputValue },
        } as React.ChangeEvent<HTMLInputElement>);
      }
    }, 500);

    return () => clearTimeout(handler);
  }, [inputValue, handleSearchQuery, searchQuery]);

  return (
    <Grid
      container
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      {/* Formulario de búsqueda */}
      <Grid item>
        <TextField
          size="small"
          variant="outlined"
          placeholder="Ej: John Doe"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          onClick={() => toggleCreateModal(true)}
          sx={{ background: "#336B87" }}
          startIcon={<PersonAddOutlinedIcon />}
        >
          Crear usuario
        </Button>
      </Grid>
    </Grid>
  );
};

export default HeadersUsersTable;
